import classnames from 'classnames/bind'
import Icon from '@/assets/icons'
import { useTranslation } from 'next-i18next'

interface SelectedItemProps {
  label?: string
  description?: string
  minPrice?: number
  maxPrice?: number
  price?: number
  isFree?: boolean
  shippingDays?: number
}
// Styles
import styles from './style.module.scss'

const LONG_SHIPPING_DAYS_THRESHOLD = 3
const cx = classnames.bind(styles)
const SelectedItem = ({ isFree, minPrice, maxPrice, shippingDays }: SelectedItemProps) => {
  const { t } = useTranslation('')
  return (
    <div className={cx('selected-option')}>
      <div className={cx('selected-option-wrapper')}>
        <div className={cx('selected-option-section-wrapper')}>
          <div className={cx('selected-option-icon')}>
            <Icon.Deliver />
          </div>
          <div className={cx('selected-option-section')}>
            <div className={cx('selected-option-heading')}>
              <div className={cx('selected-option-heading-price')}>
                {isFree ? (
                  <>
                    <div className={cx('selected-option-heading-price-value', 'discount')}>
                      NT ${minPrice}~${maxPrice}
                    </div>
                    <div className={cx('selected-option-heading-price-value')}>{t('Common_Free_Freight')}</div>
                  </>
                ) : (
                  <div className={cx('selected-option-heading-price-value')}>NT ${minPrice}</div>
                )}
              </div>
            </div>
            <div className={cx('selected-option-descroption')}>
              {shippingDays && shippingDays > LONG_SHIPPING_DAYS_THRESHOLD
                ? `${t('Common_Long_Shipping', { shippingDays })}`
                : `${t('Common_Fast_Shipping')}`}
            </div>
          </div>
        </div>
        {/* <div className={cx('selected-option-toggle')}>
          <div className={cx('selected-option-toggle-icon')}>
            <Icon.ArrowRight />
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default SelectedItem
